const line = 'https://api.line.me'
const lineMessage = 'https://asia-southeast1-wedding-invitation-dca8f.cloudfunctions.net/lineMessage'
const payment = 'https://m170v82eu6.execute-api.ap-southeast-1.amazonaws.com'

export {
  line,
  lineMessage,
  payment
}